import {validTimeZone} from './display-timezone.js';
// One layout, with independent colour, type and language preferences.
export const THEMES = ['light', 'dark'];
export const TEXT_SIZES = ['normal', 'large'];
export const LANGUAGES = ['da-DK', 'en-GB'];
export const TEXT_SCALE = 1.08;
export const appearanceKeys = ['theme', 'textSize', 'language', 'timeZone'];
export function legacyAppearance(layout) {
  const light = layout === 'simple' || layout === 'accessible';
  return { theme: light ? 'light' : 'dark', textSize: light ? 'large' : 'normal' };
}
export function validAppearancePatch(value) {
  if (!value || typeof value !== 'object' || Array.isArray(value)) return false;
  const keys = Object.keys(value);
  return keys.length > 0 && keys.every(key => appearanceKeys.includes(key))
    && (!Object.hasOwn(value, 'theme') || THEMES.includes(value.theme))
    && (!Object.hasOwn(value, 'textSize') || TEXT_SIZES.includes(value.textSize))
    && (!Object.hasOwn(value,'timeZone')||value.timeZone==='auto'||validTimeZone(value.timeZone))
    && (!Object.hasOwn(value, 'language') || LANGUAGES.includes(value.language));
}
export function resolveAppearance(value, fallbackLanguage = 'da-DK') {
  const legacy = legacyAppearance(value?.layout);
  return {
    theme: THEMES.includes(value?.theme) ? value.theme : legacy.theme,
    textSize: TEXT_SIZES.includes(value?.textSize) ? value.textSize : legacy.textSize,
    timeZone:value?.timeZone==='auto'||validTimeZone(value?.timeZone)?value.timeZone:'auto',
    language: LANGUAGES.includes(value?.language) ? value.language : fallbackLanguage,
  };
}
// The delivered UI has one readable size. Keep the legacy API values valid for
// already installed clients and rollback; normalize them only at the UI boundary.
export function resolveCustomerAppearance(value, fallbackLanguage = 'da-DK') {
  return {...resolveAppearance(value, fallbackLanguage), textSize:'large'};
}
// Return only the selected preference so persisted language/theme stay independent.
/** @returns {{theme?:'light'|'dark',language?:'da-DK'|'en-GB'}} */
export function appearanceToggle(value,key){
 const current=resolveAppearance(value);
 if(key==='theme')return {theme:current.theme==='light'?'dark':'light'};
 if(key==='language')return {language:current.language==='da-DK'?'en-GB':'da-DK'};
 throw new TypeError('Unknown appearance toggle');
}
export function scaleTypography(style, textSize) {
  if (textSize !== 'large' || typeof style?.fontSize !== 'number') return style;
  return { ...style, fontSize: Math.round(style.fontSize * TEXT_SCALE * 10) / 10,
    ...(typeof style.lineHeight === 'number' ? { lineHeight: Math.ceil(style.lineHeight * TEXT_SCALE) } : {}) };
}

// Customer text must not fall through to React Native's small default or use
// legacy 10–13 px labels. Keep a matching line height when the minimum applies.
export function readableTypography(style={}) {
  const requested=typeof style.fontSize==='number'?style.fontSize:17;
  const size=requested<=15?15:requested<=18?17:requested<=24?22:29;
  return {...style,fontSize:size,lineHeight:Math.max(Math.ceil(size*1.4),style.lineHeight??0)};
}
